import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';

import { ClearAllQuickViewsDataViewsCache } from '@resources/tests.graphql';
import V2SettingsIframe from '@aware/common/v2-settings-iframe';

import { replaceCancelButtonAction } from '../helpers';

const CreateStudentAccessList = () => {
  const history = useHistory();
  const location = useLocation();

  /**
   * This calls an API to remove the QuickViewsDataViews on the server side and also removes them client
   * side so the next time the user requests QuickViewsDataViews they'll get the correct data
   */
  const [clearAllDataViewsCache] = useMutation(ClearAllQuickViewsDataViewsCache, {
    update: cache => {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'quickViewsDataViewType' });
      cache.gc();
    }
  });

  useEffect(() => {
    window.top.resetDataViewsCache = () => {
      clearAllDataViewsCache();
    };

    return () => delete window.top.resetDataViewsCache;
  }, []);

  const redirectFn = () => {
    history.push('create-student-access-list');
  };

  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=/aware/Students/MonitorLists/NewMonitorList.aspx"
      title="Create Student Access List"
      key={location.key}
      onLoadCallback={iframe => {
        const contentDocument = replaceCancelButtonAction({ iframe, redirectFn });

        /**
         * This is only on the first page of the iframe, so we only need to do this once
         */
        contentDocument
          ?.querySelector('a[href="ManageLists.aspx"]')
          ?.addEventListener('click', () => {
            history.push('manage-my-student-access-lists');
          });
      }}
    />
  );
};

export default CreateStudentAccessList;
